import api from './api';

export interface Achievement {
  id: number;
  name: string;
  description: string;
  icon: string;
  type: 'tension' | 'headache' | 'general';
  category: 'consistency' | 'improvement' | 'milestone' | 'streak';
  condition_type: 'count' | 'streak' | 'average' | 'range' | 'custom';
  condition_value: any;
  points: number;
  rarity: 'common' | 'rare' | 'epic' | 'legendary';
  is_active: boolean;
  created_at: string;
  updated_at: string;
  // Propiedades adicionales cuando está desbloqueado
  unlocked_at?: string;
  progress?: any;
  is_new?: boolean;
  is_unlocked?: boolean;
}

export interface AchievementStats {
  total_achievements: number;
  unlocked_achievements: number;
  total_points: number;
  new_achievements: number;
  completion_percentage: number;
}

export const achievementsAPI = {
  // Obtener todos los achievements disponibles
  getAll: () => api.get('/achievements'),

  // Obtener achievements por tipo
  getByType: (type: string) => api.get(`/achievements/type/${type}`),

  // Obtener progreso de achievements del usuario
  getProgress: () => api.get('/achievements/progress'),

  // Obtener achievements desbloqueados del usuario
  getUnlocked: () => api.get('/achievements/unlocked'),

  // Obtener nuevos achievements sin ver
  getNew: () => api.get('/achievements/new'),

  // Marcar achievement como visto
  markAsSeen: (achievementId: number) => api.post(`/achievements/mark-seen/${achievementId}`),

  // Marcar todos los achievements como vistos
  markAllAsSeen: () => api.post('/achievements/mark-all-seen'),

  // Evaluar achievements manualmente
  evaluate: () => api.post('/achievements/evaluate'),

  // Obtener estadísticas de achievements
  getStats: () => api.get('/achievements/stats')
};